import { useState } from "react";

const hotSearches = ["新综艺阵容", "跨城寻人", "颁奖礼票数", "旗舰机缺货", "大厂新社交产品"];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const [searched, setSearched] = useState(false);

  const handleSearch = (kw?: string) => {
    const value = kw ?? keyword;
    if (!value.trim()) return;
    setKeyword(value);
    setSearched(true);
    document.getElementById("focus")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary-100/70 via-accent-100/30 to-background-50" aria-hidden="true"></div>
      {/* decorative blobs */}
      <div className="absolute -right-16 top-10 h-64 w-64 rounded-full bg-accent-200/50 blur-3xl" aria-hidden="true"></div>
      <div className="absolute -left-20 bottom-0 h-72 w-72 rounded-full bg-primary-200/50 blur-3xl" aria-hidden="true"></div>

      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-14 md:px-6 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:py-20">
        {/* Left copy */}
        <div className="text-center lg:text-left">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/80 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="h-2 w-2 rounded-full bg-accent-500"></span>
            全网热点 · 一瓜不落
          </span>
          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl lg:text-[2.8rem] lg:leading-[1.15]">
            吃瓜不停，围观不迷路
            <span className="block text-primary-600">今日大瓜都在这</span>
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-foreground-700 lg:mx-0 lg:text-lg">
            吃瓜聚集地是全网热点的聚集地。热门事件实时更新、群组讨论随时开趴，从娱乐八卦到互联网圈，大瓜合集一网打尽，吃瓜群众速来围观。
          </p>

          {/* Search bar */}
          <div className="mx-auto mt-7 max-w-xl lg:mx-0">
            <form
              className="flex flex-col gap-2 sm:flex-row"
              onSubmit={(e) => {
                e.preventDefault();
                handleSearch();
              }}
            >
              <label htmlFor="search-input" className="sr-only">
                搜索你想吃的话题
              </label>
              <div className="relative flex-1">
                <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-400" aria-hidden="true"></i>
                <input
                  id="search-input"
                  type="search"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜一搜你想吃的话题…"
                  className="w-full rounded-full border border-background-200 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none transition placeholder:text-foreground-400 focus:border-primary-300 focus:ring-2 focus:ring-primary-200"
                />
              </div>
              <button
                type="submit"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
              >
                <i className="ri-fire-line text-base" aria-hidden="true"></i>
                搜热点
              </button>
            </form>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-2 lg:justify-start">
              <span className="text-xs text-foreground-400">热门：</span>
              {hotSearches.map((item) => (
                <button
                  key={item}
                  type="button"
                  onClick={() => handleSearch(item)}
                  className="rounded-full border border-background-200 bg-background-50/70 px-3 py-1 text-xs text-foreground-600 transition hover:border-primary-300 hover:text-primary-700"
                >
                  # {item}
                </button>
              ))}
            </div>
          </div>

          {/* Stats */}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 lg:justify-start">
            <div>
              <p className="font-heading text-2xl font-black text-foreground-950">8.6万+</p>
              <p className="text-xs text-foreground-500">活跃吃瓜群众</p>
            </div>
            <div className="h-8 w-px bg-background-300" aria-hidden="true"></div>
            <div>
              <p className="font-heading text-2xl font-black text-foreground-950">320+</p>
              <p className="text-xs text-foreground-500">主题群组</p>
            </div>
            <div className="h-8 w-px bg-background-300" aria-hidden="true"></div>
            <div>
              <p className="font-heading text-2xl font-black text-foreground-950">24h</p>
              <p className="text-xs text-foreground-500">实时更新不停更</p>
            </div>
          </div>
        </div>

        {/* Right collage card */}
        <div className="hidden lg:block">
          <div className="relative rounded-3xl border border-background-200 bg-background-50/90 p-6 shadow-soft">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-base font-bold text-foreground-950">今日围观速报</h3>
              <span className="flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-700">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
                </span>
                实时
              </span>
            </div>
            <ul className="mt-5 space-y-3">
              {[
                { tag: "爆", t: "新综艺阵容路透不断，全网都在猜谁能进" },
                { tag: "热", t: "跨城寻人三天后反转，时间线整理出炉" },
                { tag: "新", t: "旗舰机首销秒空，黄牛加价仍有人买" },
                { tag: "热", t: "颁奖礼票数咬紧，站姐连夜冲数据" },
              ].map((row, idx) => (
                <li
                  key={idx}
                  className="flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 p-3 transition hover:border-primary-200 hover:bg-primary-50/40"
                >
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-xs font-bold text-background-50 ${
                      row.tag === "爆" ? "bg-primary-500" : row.tag === "热" ? "bg-secondary-500" : "bg-accent-500"
                    }`}
                  >
                    {row.tag}
                  </span>
                  <span className="truncate text-sm text-foreground-800">{row.t}</span>
                </li>
              ))}
            </ul>
            <a
              href="#focus"
              className="mt-5 flex items-center justify-center gap-1 rounded-full bg-background-100 py-2.5 text-sm font-medium text-primary-700 transition hover:bg-primary-100/70"
            >
              进入今日焦点
              <i className="ri-arrow-right-down-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>

      {searched && keyword && (
        <div className="relative mx-auto max-w-7xl px-4 pb-6 text-sm text-foreground-600 md:px-6">
          为你找到与「<span className="font-medium text-primary-700">{keyword}</span>」相关的最新讨论，快去看看：
          <span className="ml-1 text-accent-600">
            <i className="ri-corner-down-right-line" aria-hidden="true"></i>
          </span>
        </div>
      )}
    </section>
  );
}